import React, { useEffect, useState } from "react";
import { collection_activity_item_data } from "../../data/collection_data";
import Link from "next/link";
import Image from "next/image";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { CircularProgress } from '@mui/material';
const ClaimRider = ({
  onClaimed
}) => {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isClaiming, setIsClaiming] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [value, setValue] = useState(null);
  const [debouncedValue, setDebouncedValue] = useState('');
  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [inputValue, 500]);
  useEffect(() => {
    const getData = async () => {
      if (!debouncedValue) {
        return;
      }
      setIsLoading(true);
      const result = await fetch(`/api/claim-rider/${debouncedValue}`);
      setIsLoading(false);
      if (result.status < 300) {
        const data = await result.json();
        setOptions(data);
      }
    };
    getData();
  }, [debouncedValue]);
  const handleClaimRider = async () => {
    setIsClaiming(true);
    const result = await fetch(`/api/claim-rider/${selected}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      }
    });
    setIsClaiming(false);
    if (result.status < 300) {
      const data = await result.json();
      onClaimed(data);
    } else if (result.status === 409) {
      alert('rider already claimed');
    } else if (result.status === 404) {
      alert('unable to find this rider');
    } else {
      alert('There was an error. Please check your profile.');
    }
  };
  return <>
            <Autocomplete className="my-5" disablePortal options={options} inputValue={inputValue} onInputChange={(event, newInputValue) => {
      setInputValue(newInputValue);
    }} onChange={(event, newValue) => {
      setSelected(newValue.id);
    }} getOptionSelected={x => x.value} noOptionsText="No riders match your search criteria" renderInput={params => <TextField {...params} label="Rider Name" variant="outlined" style={{
      width: '450px'
    }} InputProps={{
      ...params.InputProps,
      endAdornment: <>
                                {isLoading ? <CircularProgress color="inherit" size={25} style={{
          position: 'relative',
          right: '-16px'
        }} /> : null}
                            </>
    }} type="text" />} data-sentry-element="Autocomplete" data-sentry-source-file="claim-rider.jsx" />
            <button disabled={!selected} onClick={handleClaimRider} className="bg-accent shadow-accent-volume hover:bg-accent-dark full-width rounded-full py-3 px-8 text-center font-semibold text-white transition-all">
                {isClaiming ? <CircularProgress color="inherit" size={25} style={{
        position: 'relative',
        marginRight: '12px'
      }} /> : null}
                Claim This Rider
            </button>
        </>;
};
export default ClaimRider;